import { IAsset, ICategory } from '../../types/damTypes';

const RECIPE_NAME_METADATA_KEY = 'receptnamn_recept_id';

function normalizeMetaValue(value: any): string {
  if (value === undefined || value === null) return '';
  if (Array.isArray(value)) {
    for (const item of value) {
      const normalized = normalizeMetaValue(item);
      if (normalized) return normalized;
    }
    return '';
  }
  return String(value).trim();
}

export function getRecipeDisplayNameFromMetadata(metadata: Record<string, any> | undefined): string {
  if (!metadata) return '';

  const direct = normalizeMetaValue((metadata as any)[RECIPE_NAME_METADATA_KEY]);
  if (direct) return direct;

  for (const [key, value] of Object.entries(metadata)) {
    if (String(key || '').trim().toLowerCase() !== RECIPE_NAME_METADATA_KEY) continue;
    const normalized = normalizeMetaValue(value);
    if (normalized) return normalized;
  }

  return '';
}

export function isAssetUnderNamedCategoryRoot(
  asset: IAsset | null,
  allCategories: ICategory[],
  rootNameLower: string,
): boolean {
  if (!asset?.categories || asset.categories.length === 0) return false;

  const matchesNamedRoot = (categoryId: string, visited = new Set<string>()): boolean => {
    if (!categoryId || visited.has(categoryId)) return false;
    visited.add(categoryId);

    const category = allCategories.find((entry) => entry._id === categoryId);
    if (!category) return false;

    if (String(category.name || '').trim().toLowerCase() === rootNameLower) {
      return true;
    }

    const parentId = typeof category.parentCategory === 'string'
      ? category.parentCategory
      : (category.parentCategory as any)?._id;

    return parentId ? matchesNamedRoot(String(parentId), visited) : false;
  };

  return asset.categories.some((categoryId) => matchesNamedRoot(String(categoryId)));
}

export function getRecipeImpactCollectionName(asset: IAsset | null, fallbackTitle?: string): string {
  const recipeTitle = getRecipeDisplayNameFromMetadata(asset?.metadata)
    || String(fallbackTitle || '').trim()
    || String(asset?.title || '').trim()
    || String(asset?.fileName || '').trim()
    || 'Recept';
  const timestamp = new Date().toISOString().slice(0, 16).replace(/[-:T]/g, '');
  const baseName = `Påverkade produkter - ${recipeTitle}`;
  const suffix = ` - ${timestamp}`;
  const maxBaseLength = Math.max(1, 128 - suffix.length);
  return `${baseName.slice(0, maxBaseLength)}${suffix}`;
}

export function getProductImpactCollectionName(asset: IAsset | null, fallbackTitle?: string): string {
  const productTitle = String(fallbackTitle || '').trim()
    || String(asset?.title || '').trim()
    || String(asset?.fileName || '').trim()
    || 'Produkt';
  const timestamp = new Date().toISOString().slice(0, 16).replace(/[-:T]/g, '');
  const baseName = `Påverkade recept - ${productTitle}`;
  const suffix = ` - ${timestamp}`;
  const maxBaseLength = Math.max(1, 128 - suffix.length);
  return `${baseName.slice(0, maxBaseLength)}${suffix}`;
}
